export default __webpack_public_path__ + "static/media/avs_logo_blanco2.26cdb533.png";